import { useTranslation } from 'react-i18next';

import { dayjs } from 'src/utils/dayjs-config.utils';

export const useFormatAssignmentDueDate = () => {
  const { t } = useTranslation();

  const formatAssignmentDueDate = (
    date: Date,
    isMiddleSchoolView = false,
    isK1Theme = false,
  ) => {
    if (dayjs(date).isToday()) {
      return t('Today');
    }

    if (isMiddleSchoolView) {
      return dayjs(date).format('MMM D, h:mm A'); // May 24, 11:59 PM
    }

    if (isK1Theme) {
      return dayjs(date).format('MMMM Do'); // March 24th
    }

    return dayjs(date).format('MMM Do'); // Mar 24th
  };

  return formatAssignmentDueDate;
};
